module.exports = __webpack_public_path__ + "static/media/maroof3.27de384e.jpg";